import Icon from "components/Icon/Icon";
import { useTranslation } from "react-i18next";
import { Profile } from "types/Profile";

function ProfileBadges({
  profile,
  noText = false,
  isSmall = false,
  classname = "",
}: {
  profile: Profile;
  noText?: boolean;
  isSmall?: boolean;
  classname?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-row gap-2 items-center justify-start ${classname}`}
    >
      {profile?.isProvider && (
        <div
          className={`flex items-center gap-1 font-normal leading-[0] text-center text-white bg-slate-500 rounded-full shrink-0 ${
            isSmall ? "px-1 py-0.5" : "px-2 py-1"
          }`}
        >
          <Icon
            name="Provider"
            className={`${isSmall ? "w-4 h-4" : "w-5 h-5"}`}
          />
          {!noText && ` ${t("common.provider")}`}
        </div>
      )}
      {profile?.isCompany && (
        <div
          className={`flex items-center gap-1 font-normal leading-[0] text-center text-white ${
            profile?.verified ? "bg-green-500" : "bg-red-500"
          } rounded-full shrink-0 ${isSmall ? "px-1 py-0.5" : "px-2 py-1"}`}
        >
          <Icon
            name={profile?.verified ? "CheckIcon" : "XMarkIcon"}
            className={`${isSmall ? "w-4 h-4" : "w-5 h-5"}`}
          />
          {!noText &&
            ` ${
              profile?.verified
                ? t("common.verifiedPro")
                : t("common.nonVerifiedPro")
            }`}
        </div>
      )}
    </div>
  );
}

export default ProfileBadges;
